var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("dashboard.commentDialogTitle"),
        visible: _vm.visible,
        width: "50%",
        "before-close": _vm.cancelComment,
      },
    },
    [
      _c("p", { staticClass: "likeWrap" }, [
        _c("img", {
          staticClass: "likeIcon",
          attrs: {
            src: _vm.form.actionLikes === 1 ? _vm.likeBlue : _vm.likeGray,
            alt: "comment",
          },
          on: { click: _vm.toggleLike },
        }),
      ]),
      _vm._v(" "),
      !_vm.currentRow.hasOwnProperty("selected")
        ? _c("h2", { staticClass: "sortTitle" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("dashboard.sortNum"))),
            ]),
            _vm._v("\n    " + _vm._s(_vm.currentRow.rowNumber) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          class: _vm.currentRow.hasOwnProperty("selected") ? "mt_40" : "",
          attrs: {
            model: _vm.form,
            size: "small",
            "label-position": "left",
            "label-width": "60px",
          },
        },
        [
          !_vm.currentRow.hasOwnProperty("selected") && _vm.asmList.length
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("dashboard.filter.asm") + ":" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      staticClass: "check-group",
                      attrs: { value: _vm.form.asm, size: "mini" },
                    },
                    _vm._l(_vm.asmList, function (asmItem, asmIndex) {
                      return _c(
                        "el-checkbox",
                        {
                          key: asmIndex,
                          staticClass: "check-item",
                          attrs: { label: asmItem.email, border: "" },
                          on: {
                            change: function (val) {
                              return _vm.asmChange(
                                val,
                                asmItem.email,
                                asmItem.empName
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(asmItem.empName))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.formErrors.asm
                    ? _c("p", { staticClass: "formError" }, [
                        _vm._v(_vm._s(_vm.formErrors.asm)),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.currentRow.hasOwnProperty("selected") && _vm.srList.length
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("dashboard.filter.sr") + ":" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      staticClass: "check-group",
                      attrs: { value: _vm.form.sr, size: "mini" },
                    },
                    _vm._l(_vm.srList, function (srItem, srIndex) {
                      return _c(
                        "el-checkbox",
                        {
                          key: srIndex,
                          staticClass: "check-item",
                          attrs: { label: srItem.email, border: "" },
                          on: {
                            change: function (val) {
                              return _vm.srChange(
                                val,
                                srItem.email,
                                srItem.empName
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(srItem.empName))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.formErrors.sr
                    ? _c("p", { staticClass: "formError" }, [
                        _vm._v(_vm._s(_vm.formErrors.sr)),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { prop: "mediaUrl", label: _vm.$t("common.uploadImage") },
            },
            [
              _c(
                "el-upload",
                {
                  attrs: {
                    action: "",
                    "auto-upload": false,
                    "list-type": "picture-card",
                    "on-preview": _vm.handlePictureCardPreview,
                    "on-remove": _vm.handleRemove,
                    "on-change": _vm.uploadImage,
                  },
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentRow.hasOwnProperty("selected")
            ? _c("div", { staticClass: "light-blue-board" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dashboard.hasChoose")) +
                    " " +
                    _vm._s(
                      _vm.currentRow.selected
                        .map(function (t) {
                          return t[_vm.currentRow.nameKey]
                        })
                        .join(",")
                    ) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.currentRow.hasOwnProperty("selected")
            ? _c("p", { staticClass: "mt_20" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dashboard.commentInfo")) +
                    "\n    "
                ),
              ])
            : _c("p", { staticClass: "mt_20" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.showBatchCommentDesc) + "\n    "
                ),
              ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt_20" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.form.category === "1" ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      _vm.updateCategory("1", _vm.$t("dashboard.excellent"))
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dashboard.excellent")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.form.category === "2" ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      _vm.updateCategory("2", _vm.$t("dashboard.goodJob"))
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dashboard.goodJob")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.form.category === "3" ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      _vm.updateCategory("3", _vm.$t("dashboard.perfect"))
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dashboard.perfect")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt_20" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 },
                  placeholder: _vm.$t("dashboard.comment_hintText"),
                },
                on: { change: _vm.descChange },
                model: {
                  value: _vm.form.desc,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "desc", $$v)
                  },
                  expression: "form.desc",
                },
              }),
              _vm._v(" "),
              _vm.formErrors.desc
                ? _c("p", { staticClass: "formError" }, [
                    _vm._v(_vm._s(_vm.formErrors.desc)),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.cancelComment } }, [
            _vm._v(_vm._s(_vm.$t("common.cancel"))),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitComment } },
            [_vm._v(_vm._s(_vm.$t("common.send")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }